/** @jsx jsx */

import { jsx, render, SelectionSet, Field, Variable, Mutation, BooleanScalar, StringScalar } from "graphql-jsx";
import { clients } from "utils/clients";
import { UuidScalar } from "GraphQL/Scalars";

type Option = Readonly<{
  id: string;
  copyright?: boolean;
  neighboring?: boolean;
  notice?: string;
}>;

export const UpdateTrackLicenseRight = async (option: Option) => {
  const $uuid = <Variable name="id" scalar={<UuidScalar />} value={option.id} />;
  const $copyright = <Variable name="copyright" scalar={<BooleanScalar isNullable />} value={option.copyright} />;
  const $neighboring = <Variable name="neighboring" scalar={<BooleanScalar isNullable />} value={option.neighboring} />;
  const $notice = <Variable name="notice" scalar={<StringScalar isNullable />} value={option.notice} />;
  const { query, variables } = render(
    <Mutation operationName="UPDATE_TRACK_LICENSE_RIGHT">
      <SelectionSet
        name="updateTrack_license"
        alias="updateTrackLicense"
        argument={{
          where: {
            id: $uuid
          },
          data: {
            copyright: $copyright,
            neighboring: $neighboring,
            notice: $notice
          }
        }}
      >
        <Field name="id" />
      </SelectionSet>
    </Mutation>
  );
  type Data = Readonly<{
    updateTrackLicense: Readonly<{
      id: string;
    }>[];
  }>;
  return await clients.metadata.request<Data>(query, variables);
};
